import React from "react";
import PropTypes from "prop-types";
import NavigationLink from "components/layout/GuideNavigation";
import { Layout, Space, Badge, theme } from "antd";
import { useTranslation } from "react-i18next";
import { oldRoutes } from "router/old-routes";
import { useScrollToActive } from "hooks/useScrollToActive";
import { scrollToActive } from "helpers/DOM";
import { useSelector } from "react-redux";

GuideNavigation.propTypes = {
  className: PropTypes.string,
};

export default function GuideNavigation({ className }) {
  const { t } = useTranslation();
  const navigationRef = useScrollToActive();
  const { metadata } = useSelector((store) => store.conversations);
  const totalUnviewed = metadata.total_unviewed_messages;
  const { token } = theme.useToken();

  const classes = ["guide-navigation-ant", "bg-white", "shadow"];
  if (className) classes.push(className);

  const clickHandler = ({ currentTarget }) => scrollToActive(currentTarget);

  return (
    <Layout.Header
      className={classes.join(" ")}
      style={{ background: token.colorBgContainer, boxShadow: token.boxShadowSecondary, padding: 0 }}
    >
      <div
        className="full-window-scroll"
        ref={navigationRef}
        style={{ overflowX: "auto", width: "100%" }}
      >
        <Space
          size={24}
          style={{ padding: "10px 0 10px 24px", minHeight: 64, display: "flex", flexWrap: "wrap" }}
        >
          <NavigationLink
            to={oldRoutes.guideDashboardPath()}
            iconName="Dashboard"
            label={t("guide.navigation.dashboard")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideBookingsPath()}
            iconName="Bookings"
            label={t("guide.navigation.bookings")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideClientsPath()}
            iconName="Customers"
            label={t("guide.navigation.clients")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideTripsPath()}
            iconName="Trips"
            label={t("guide.navigation.trips")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideBoatsPath()}
            iconName="Boats"
            label={t("guide.navigation.boats")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideMessagesPath()}
            iconName="Messages"
            label={t("guide.navigation.messages")}
            onClick={clickHandler}
            badge={totalUnviewed > 0 && <Badge count={totalUnviewed} offset={[8, -4]} />}
          />
          <NavigationLink
            to={oldRoutes.guideAccountingPath()}
            iconName="Accounting"
            label={t("guide.navigation.accounting")}
            onClick={clickHandler}
          />
          <NavigationLink
            to={oldRoutes.guideMarketingPath()}
            iconName="Marketing"
            label={t("guide.navigation.marketing")}
            onClick={clickHandler}
          />
          {/* <NavigationLink
            to={oldRoutes.guideWeatherPath()}
            iconName="Weather"
            label={t("guide.navigation.weather")}
            onClick={clickHandler}
          /> */}
        </Space>
      </div>
    </Layout.Header>
  );
}
